// extracted by mini-css-extract-plugin
module.exports = {"main-component":"blocker_main-component__3HVJ9"};